import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { GridContainer, Grid, GridMiddleChild } from './styles';

import ViewGraphicsComponent from '../ViewGraphicsComponent';

const ModalElementGraphics = props => {
  const { modalShow, onHide, graphicList, MapProps, layer, indexGraphic } = props;

  return (
    <Modal
      show={modalShow}
      size="lg"
      dialogClassName="w-75 mw-100 mh-100"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={() => {
        onHide();
      }}
      centered
    >
      <Modal.Header closeButton className="p-2">
        {!isEmpty(graphicList) && <h1>{graphicList[indexGraphic].name}</h1>}
      </Modal.Header>
      <Modal.Body style={{ height: '85vh', width: '100%' }}>
        <GridContainer heightToRemove="5%">
          <Grid>
            <GridMiddleChild height="100%" xs={12}>
              {!isEmpty(graphicList) && (
                <>
                  <ViewGraphicsComponent
                    aspectRatio={1.5}
                    history={MapProps.history}
                    layerId={layer._id}
                    graphicId={graphicList[indexGraphic]._id}
                    modal={modalShow}
                  />
                </>
              )}
            </GridMiddleChild>
          </Grid>
        </GridContainer>
      </Modal.Body>
    </Modal>
  );
};
ModalElementGraphics.defaultProps = {
  modalShow: false,
  onHide: () => {},
  graphicList: [],
  indexGraphic: 0,
  layer: {},
  MapProps: {}
};
ModalElementGraphics.propTypes = {
  modalShow: PropTypes.bool,
  onHide: PropTypes.func,
  graphicList: PropTypes.array,
  indexGraphic: PropTypes.number,
  layer: PropTypes.object,
  MapProps: PropTypes.object
};
export default ModalElementGraphics;
